import BuildItemsView from './BuildItemsView';

interface BuildPlanTabProps {
  initialProject?: string;
  initialAnchor?: string;
}

/**
 * Build Plan Tab - Wraps BuildItemsView component
 * Filters items to only show build projects (intake, tender, build, defects, archive)
 * Excludes service and inactive projects
 */
const BuildPlanTab = ({ initialProject, initialAnchor }: BuildPlanTabProps) => {
  return (
    <BuildItemsView 
      initialProject={initialProject}
      initialAnchor={initialAnchor}
    />
  );
};

export default BuildPlanTab;
